import { TRACK_EVENT, trackEvent } from '../../utils/analytics';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    container: {
        width: 250,
    },
    title: {
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '22px',
        textAlign: 'center',
    },
    content: {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#767676',
        textAlign: 'center',
    },
    list: {
        marginTop: 8,
        marginBottom: 16,
    },
    link: {
        color: 'inherit',
    },
}));

interface IAppVersionContentProps {
    releaseFeatures?: any;
    userDetail?: any;
}

const AppVersionContent = ({ releaseFeatures, userDetail }: IAppVersionContentProps) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <h1 className={classes.title}>New Version Available</h1>
                <p className={classes.content}>
                    A new version of Taffi app is available. It provides improved stability and user experience.
                    {!!releaseFeatures?.length && (
                        <>
                            <br />
                            <br />
                            New feature includes:
                            <ul className={classes.list}>
                                {releaseFeatures.map((it) => (
                                    <li key={it.path}>
                                        <span
                                            onClick={() =>
                                                trackEvent(TRACK_EVENT.RELEASE_FEATURES, {
                                                    userId: userDetail?.id,
                                                    featureName: it.content,
                                                })
                                            }
                                        >
                                            <a href={it.path} className={classes.link}>
                                                {it.content}
                                            </a>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </p>
            </div>
        </div>
    );
};

export default AppVersionContent;
